<template>
  <v-container>
    <v-dialog
    :value="value"
    @input="(v) => v || closeUploadLasFileDialog()"
    max-width="500px"
    >
    <v-card>
        <v-card-title>
          <span class="headline">点群ファイルをアップロード</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-container class="pb-0">
            <v-form
              ref="uploadLasFileForm"
              v-model="uploadLasFileFormValid"
              lazy-validation
            >
              <span>* アプリを選択してください。</span>
              <v-select
                  hide-details="auto"
                  v-model="inputFileUpload.app"
                  label="アプリ種類 *"
                  :items="apps"
                  required
                  :rules="[(v) => !!v || 'アプリ種類を選択してください。']"
                  outlined
                  clearable
                  dense
              ></v-select>
              <span>* ファイルを選択してください。</span>
              <v-file-input
                hide-details="auto"
                v-model="inputFileUpload.file"
                label="ファイル選択 *"
                required
                :rules="[(v) => !!v || 'ファイルを選択してください。']"
                outlined
                clearable
                dense
            ></v-file-input>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn depressed @click="closeUploadLasFileDialog">キャンセル</v-btn>
          <v-btn depressed color="primary" @click="uploadLasFile">アップロード</v-btn>
        </v-card-actions>
    </v-card>
    </v-dialog>
    <v-dialog v-model="uploadingDialog" width="initial" persistent>
      <div class="overlay-content">
        <h4 class="mb-3">
          処理中です。戻るや画面更新やブラウザ閉じる操作を行わないでください。
        </h4>
        <div>
          <v-progress-linear
            v-model="uploadRate"
            height="25"
          >
            <strong>{{ Math.ceil(uploadRate) }}%</strong>
          </v-progress-linear>
        </div>
        <div v-if="loading === 'completing'">
          <v-progress-circular
              size="22"
              indeterminate
              color="primary"
          ></v-progress-circular>
          <v-icon v-if="loading === 'done'" color="green"
          >mdi-check-circle</v-icon
          >
          <span>処理中</span>
        </div>
      </div>
    </v-dialog>
  </v-container>
</template>
<script>
import {store} from "@/store";
import S3Axios from "@/utils/s3Axios";
export default {
  name: "H2pUploadLasFileDialog",
  props: ["value", "folder_id"],
  data() {
    return {
      uploadLasFileFormValid: true,
      inputFileUpload: {
        app: null,
        file: null,
        fileType: "las",
        colorType: "color",
      },
      apps: ["dronedeploy", "terra", "pix4d", "airprobe", "opendronemap", "opendronemap_lightning"],
      uploadingDialog: false,
      uploadedFilesNum: 0,
      uploadFilesNum: 0,
      uploadRate: 0,
      loading: "done",
      s3Axios: new S3Axios(this.axios).s3Axios
    };
  },
  methods: {
    uploadLasFile() {
      if (this.$refs.uploadLasFileForm.validate()) {
        if (!this.inputFileUpload.file) return;
        this.uploadRate = 0;
        this.uploadedFilesNum = 0;
        this.uploadFilesNum = 1;
        this.loading = "uploading";
        this.uploadingDialog = true;
        const data = new FormData();
        data.append("folder_id", this.folder_id);
        data.append("app", this.inputFileUpload.app);
        data.append("name", this.inputFileUpload.file.name);
        data.append("file_size", this.inputFileUpload.file.size);
        data.append("file_type", this.inputFileUpload.fileType);
        data.append("color_type", this.inputFileUpload.colorType);
        this.axios.post("/api/file/presigned-urls", data)
            .then(response => {
              const pData = response.data;
              const promises = [];
              let uploadedPartCount = 0;
              for (let i = 0; i < pData.partCount; i++) {
                const start = i * pData.partSize;
                const end = (i + 1) * pData.partSize;
                const blob = i + 1 < pData.partCount ? this.inputFileUpload.file.slice(start, end) : this.inputFileUpload.file.slice(start);
                promises.push(
                  this.s3Axios.put(pData.presignedUrls[i], blob)
                    .then(() => {
                      uploadedPartCount++;
                      this.uploadRate = 100 * uploadedPartCount / pData.partCount;
                    })
                );
              }
              Promise.all(promises)
                .then(() => {
                  this.loading = "completing";
                  data.append("path", pData.path);
                  data.append("uploadId", pData.uploadId);
                  this.axios.post("/api/file/complete-multipart-upload", data)
                    .then(() => {
                      store.showSuccessDialog("アップロードが完了しました。");
                    })
                    .catch(() => {
                      store.showErrorDialog("エラーが発生しました。再度アップロードしてください。");
                    })
                    .finally(() => {
                      this.closeUploadLasFileDialog();
                      this.loading = "done";
                      this.uploadingDialog = false;
                    })
                })
                .catch(() => {
                  store.showErrorDialog("エラーが発生しました。再度アップロードしてください。");
                  this.closeUploadLasFileDialog();
                  this.loading = "done";
                  this.uploadingDialog = false;
                })
            })
            .catch(() => {
              store.showErrorDialog("エラーが発生しました。再度アップロードしてください。");
              this.closeUploadLasFileDialog();
              this.loading = "done";
              this.uploadingDialog = false;
            })
      }
    },
    
    closeUploadLasFileDialog() {
      this.$refs.uploadLasFileForm.reset();
      this.$emit("input");
    },
  },
};
</script>
